import {Node} from "../../../model/Graph";
import {parse} from "../../json/json-comment-wrapper";

export const parseNodeMetadata = (node: Node): Record<string, any> => {
  return parseRawNodeMetadata(node.getMetadata());
}

export const parseRawNodeMetadata = (meta: string | null): Record<any, any> => {

  if(!meta) {
    return  {};
  }

  try {
    return parse(meta);
  } catch (e) {
    console.error("Failed to parse metadata of node: ",  meta);
    return {};
  }
}
